import React, { FC } from 'react';
import { WarningCircleIcon } from '@fronton/icons-react';
import { Snack } from 'fronton-react';
import { t } from 'i18next';

export const DATA_QA_NOTIFICATION = 'reviews-error-notification';

type Props = {
  id: string;
};

export const ReviewsErrorNotification: FC<Props> = ({ id }) => (
  <Snack
    autoHideTimer={5000}
    key={id}
    id={id}
    variant="error"
    data-qa={DATA_QA_NOTIFICATION}
    icon={<WarningCircleIcon type="outline" size="l" color="brand-invert" />}
    header={t('reviews.ui.pagination.error.header')}
    paragraph={t('reviews.ui.pagination.error.paragraph')}
  ></Snack>
);
